const WHITELIST_ACTIONS = ["whitelist", "unblock", "allow"];
const WHITELIST_DOMAINS = ["wetransfer.com", "nordvpn.com", "torproject.org"];

const actionPattern = WHITELIST_ACTIONS.join("|");
const domainPattern = WHITELIST_DOMAINS.map((domain) =>
    domain.replace(/\./g, "\\.")
).join("|");

// Matches when the text contains one of the whitelist actions (whitelist/unblock/allow)
// and one of the known domains, in either order, with any other text around/between them.
const whitelistRegex = new RegExp(
    `(?:\\b(?:${actionPattern})\\b.*\\b(?:${domainPattern})\\b)|(?:\\b(?:${domainPattern})\\b.*\\b(?:${actionPattern})\\b)`,
    "i"
);

export const isWhitelistRequest = (text: string): boolean =>
    whitelistRegex.test(text);

export const getWhitelistRequestWebsite = (text: string): string | null => {
    const websiteMatch = text.match(
        new RegExp(`\\b(${domainPattern})\\b`, "i")
    );
    return websiteMatch?.[1]?.toLowerCase() ?? null;
};

// Matches an intent to raise/ask about an SSL bypass, e.g. "raise a ssl bypass request" or
// "bypass ssl inspection". Unlike the whitelist regex, no domain is required: the prompts that
// should trigger this flow (e.g. "I want to raise a ssl bypass request") never mention a website.
const sslBypassRegex = /\bssl\b.*\b(?:bypass|inspection)\b|\b(?:bypass|inspection)\b.*\bssl\b/i;

export const isSslBypassRequest = (text: string): boolean =>
    sslBypassRegex.test(text);
